import { t } from '@hefe/i18n';
import { Inventory } from '@hefe/models';
import { InventoryApi } from '@hefe/store';
import { fullUserName } from '@hefe/utils';
import { Descriptions, Tabs } from 'antd';
import InventoryTransfersComponent from '../inventory-transfers/inventory-transfers.component';

interface InventoryDetailsComponentProps {
  inventory: Inventory;
  adminView?: boolean;
}

export default function InventoryDetailsComponent(
  props: InventoryDetailsComponentProps
) {
  const { inventory, adminView } = props;

  const { data: inventoryDetails, isFetching: isFetchingInventory } =
    InventoryApi.useFetchInventoryQuery(inventory.id);

  return (
    <Tabs
      items={[
        {
          key: 'details',
          label: t('inventory.details.title'),
          children: (
            <Descriptions
              title={t('inventory.details.title')}
              column={1}
              bordered
            >
              <Descriptions.Item label={t('inventory.details.name')}>
                {inventory.name}
              </Descriptions.Item>
              <Descriptions.Item label={t('inventory.details.description')}>
                {inventory.description}
              </Descriptions.Item>
              <Descriptions.Item label={t('inventory.details.category')}>
                {inventory?.category?.name ??
                  t('inventory.categories.uncategorized')}
              </Descriptions.Item>
              <Descriptions.Item label={t('inventory.possessor.title')}>
                {inventory.possessor
                  ? fullUserName(inventory.possessor)
                  : t('inventory.pool.title')}
              </Descriptions.Item>
            </Descriptions>
          ),
        },
        {
          key: 'transfers',
          label: t('inventory.transfers.history'),
          children: (
            <InventoryTransfersComponent
              inventory={inventoryDetails ?? inventory}
              loading={isFetchingInventory}
            />
          ),
        },
      ]}
    />
  );
}
